import { FormElems } from 'components';
import DatePicker from 'components/DatePicker';
import { MLE_CREATE_FORM_NAME } from 'components/Onboarding/Mle/BusinessTab/contants';
import MyTooltip from 'components/Onboarding/Mle/BusinessTab/MyTooltip';
import { ERROR_FETCH, FILE_MSG, FORMAT_DATE, IMAGE_MSG, PAN } from 'components/Onboarding/Mle/mle.constants';
import {
    allowedExtensions,
    checkPiiData,
    comparePanDetails,
    fetchFieldValue,
    fetchPiiData,
    getFormattedDateusingUrl,
    handlePiiUpload,
    handleVerifyPiiAccount,
    handleViewClick,
    hasDuplicates,
    isApproved,
    isPanVerifyDisable,
    isRejected,
    redClassRemarksCond,
    replaceSquareBraces,
    VERIFIED,
} from 'components/Onboarding/Mle/mle.utils';
import TitleComponent from 'components/TitleComponent';
import VerifyButton from 'components/VerifyButton/VerifyButton';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Field } from 'redux-form';
import { EVENT_TYPES, MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';

const PanOcr = props => {
    const {
        fields,
        formName,
        actions,
        setPiiData,
        setIsUploading,
        piiData,
        isViewMode,
        setSelectedDocument,
        setIsPiiVerified,
        itemCount,
        isPiiVerified,
        values,
        checkerRemarks,
        setIntentId = null,
        intentId,
        clearClicked,
        panNumbers=[],
        isEditMode,
        infoMsgs,
        entityId,
        isReEditFlow,
        panInfoMsg,
        initialValues = {},
        createdAt=null,
        setDocTimeStamp = null,
        checkoutMigrated
    } = props;

    const [panDate, setPanDate] = useState(fetchFieldValue(values, fields.panDate.name) || null);
    const [focusedInput, setFocusedInput] = useState();
    const [isPanVerified, setIsPanVerified] = useState(false);
    const [verifiedDetails, setVerifiedDetails] = useState(null);

    // useEffect(() => {
    //     if (values[fields.panUpload.reqname]) {

    //     }
    // }, []);

    useEffect(() => {
        
        if (clearClicked)
            setPanDate(null);
    }, [clearClicked]);
    

    useEffect(() => {
        let panUploaded = piiData[PAN];
        

        if (panUploaded?.documentDetails) {
            let documentDetails = panUploaded?.documentDetails;
            let dob = moment(documentDetails.dob?.value);
            if (documentDetails.panNumber?.value) {
                actions.change(
                    formName,
                    fields.pan.name,
                    documentDetails.panNumber?.value
                );
            } else {
                actions.change(
                    formName,
                    fields.pan.name,
                    null
                );
            }
            if (documentDetails.dob?.value) {
                actions.change(
                    formName,
                    fields.panDate.name,
                    dob.format(FORMAT_DATE)
                );
                setPanDate(dob);
            } else {
                actions.change(
                    formName,
                    fields.panDate.name,
                    null
                );
                setPanDate(null);
            }
            if (documentDetails.name?.value) {
                actions.change(
                    formName,
                    fields.panName.name,
                    documentDetails.name?.value
                );
            } else {
                actions.change(
                    formName,
                    fields.panName.name,
                    null
                );
            }
        }
    }, [piiData[PAN]?.documentDetails?.panNumber?.value, piiData[PAN]?.documentDetails?.dob?.value, piiData[PAN]?.documentDetails?.name?.value]);



    const handleChangePan = (val) => {
        try{
            setPiiData((data) => {
                
                let piiCode = data;
                checkPiiData(piiCode, PAN, 'panNumber')
                
                piiCode[PAN].documentDetails.panNumber.value = val;
                
                return piiCode
            });
        } catch(e) {
            console.log("e message", e.message);
        }

    }
    const handleChangePanName = (val) => {
        try {
            setPiiData((data) => {
                let piiCode = data;
                checkPiiData(piiCode, PAN, 'name')
                piiCode[PAN].documentDetails.name.value = val;
                return piiCode;
            });
        } catch(e) {

        }

    }
    const handleDateChange = (date) => {
        
        if (date) {
            setPiiData((data) => {
                let piiCode = data;
                checkPiiData(piiCode, PAN, 'dob')
                
                piiCode[PAN].documentDetails.dob.value = date.format(FORMAT_DATE);
                
                return piiCode;
            });
        }
    }
    const isPanUrlRequired = fields.panUpload?.fieldValidations?.required;

    useEffect(() => {
        if (fetchFieldValue(initialValues, fields.pan.name) && fetchFieldValue(initialValues, fields.panName.name) && fetchFieldValue(initialValues, fields.panDate.name)) {
            let panNumber = fetchFieldValue(initialValues, fields.pan.name) || null;
            let panName = fetchFieldValue(initialValues, fields.panName.name) || null;
            let panDate = fetchFieldValue(initialValues, fields.panDate.name) || null;
            if (panNumber && panName && panDate) {
                setVerifiedDetails((prev) => {
                    const panObj = {};
                    panObj[PAN] = {
                        documentDetails: {
                            panNumber: {
                                value: panNumber,
                            },
                            name: {
                                value: panName,
                            },
                            dob: {
                                value: panDate,
                            },
                        }
                    }
                    if (!prev) {
                        return panObj;
                    }
                    return {
                        ...prev,
                        ...panObj
                    }
                })
            }

        }
    }, [fetchFieldValue(initialValues, fields.pan.name), fetchFieldValue(initialValues, fields.panName.name), fetchFieldValue(initialValues, fields.panDate.name)]);

    useEffect(() => {
        let panVerified = fetchFieldValue(values, fields.verifyPan.name) || false;
        if (!isPanUrlRequired && verifiedDetails) {
            const panUploaded = verifiedDetails[PAN];
            let isDetailsMatch = comparePanDetails(panUploaded, values, fields);
            panVerified = isDetailsMatch && panVerified;
        }
        setIsPanVerified(panVerified);
        setIsPiiVerified(prev => {
            if (prev?.[PAN]?.verifiedStatus !== undefined)
                prev[PAN].verifiedStatus = panVerified?VERIFIED:'';
            return prev;
        })
    }, [fetchFieldValue(values, fields.pan.name), fetchFieldValue(values, fields.panName.name), fetchFieldValue(values, fields.panDate.name), fetchFieldValue(values, fields.verifyPan.name), verifiedDetails]);
    const disableOtherFields = ((!piiData?.[PAN]?.s3Url || isPanVerified) && isPanUrlRequired);
    // console.log("disableOtherFields", disableOtherFields);
    const isPanVerifyButtonDisable = hasDuplicates(panNumbers);

    const infoElementMsg = `${IMAGE_MSG}${allowedExtensions.join(', ')}`;    
    
    return (
        <>
            <div className="form-field uploadDivContainer">
                <TitleComponent 
                    field={fields.panUpload}
                    checkerRemarks={checkerRemarks}
                    isEditMode={isEditMode}
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={fields.panUpload.reqname}
                    fieldDate={getFormattedDateusingUrl(fetchFieldValue(values, fields.panUpload.reqname), createdAt)}
                />
                <div className='uploadFileContainer'>
                <Field
                    handleChange={(_, url) => {
                        if (!url)
                            actions.change(formName, fields.panUpload.reqname, null);
                    }}
                    uploadImageAndGetURL={file => {
                        actions.change(
                            formName,
                            fields.verifyPan.name,
                            false
                        );
                        return handlePiiUpload({
                            file: file,
                            type: PAN,
                            name: fields.panUpload.reqname,
                            actions: actions,
                            setPiiData: setPiiData,
                            setIsPiiVerified: setIsPiiVerified,
                            setIsUploading: setIsUploading,
                            formName: formName,
                            isEditMode: isEditMode || isReEditFlow,
                            entityId: entityId,
                            checkerRemarks: checkerRemarks,
                            fields: fields,
                        });
                    }}
                    docUrl={piiData?.[PAN]?.s3Path || piiData?.[PAN]?.s3Url || ''}
                    handleView={docUrl =>
                        handleViewClick(
                            docUrl,
                            setIsUploading,
                            setSelectedDocument,
                            setDocTimeStamp,
                            createdAt,
                            checkoutMigrated
                        )
                    }
                    component={FormElems.UploadElement}
                    name={fields.panUpload.name}
                    type={fields.panUpload.type}
                    id={fields.panUpload.reqname}
                    placeholder={fields.panUpload.label}
                    allowedExtensions={allowedExtensions}
                    MaxFileSize={fields.panUpload.maxFileSize}
                    accept={fields.panUpload.accept}
                    infoElement={infoElementMsg}
                    isActionIcon
                    disabled={
                        isViewMode ||
                        (isApproved(checkerRemarks, fields.panUpload.reqname, null, isEditMode) &&
                        isApproved(checkerRemarks, fields.pan.name, null, isEditMode) &&
                        isApproved(checkerRemarks, fields.panName.name, null, isEditMode) &&
                        isApproved(checkerRemarks, fields.panDate.name, null, isEditMode))
                    }
                    labelName={"PAN Document"}
                />
                </div>
            </div>
            <div className="form-field">
                <TitleComponent 
                    field={fields.pan} 
                    checkerRemarks={checkerRemarks} 
                    isEditMode={isEditMode} 
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={fields.pan.name}
                />
                <Field
                    name={fields.pan.name}
                    type={fields.pan.type}
                    id={fields.pan.name}
                    component={FormElems.Input}
                    placeholder={fields.pan.label}
                    onChange={handleChangePan}
                    uppercase
                    disabled={
                        isViewMode ||
                        disableOtherFields || 
                        isApproved(checkerRemarks, fields.pan.name, null, isEditMode)
                    }
                    style={{ 'text-transform': 'uppercase' }}
                />
            </div>
            <div className="form-field">
                <TitleComponent 
                    field={fields.panName} 
                    checkerRemarks={checkerRemarks} 
                    isEditMode={isEditMode} 
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={fields.panName.name}
                />
                <Field
                    name={fields.panName.name}
                    type={fields.panName.type}
                    id={fields.panName.name}
                    component={FormElems.Input}
                    placeholder={fields.panName.label}
                    onChange={handleChangePanName}
                    disabled={
                        isViewMode ||
                        disableOtherFields ||
                        isApproved(checkerRemarks, fields.panName.name, null, isEditMode)
                    }
                    infoElement={panInfoMsg}
                />
            </div>
            <div className="form-field">
                <TitleComponent 
                    field={fields.panDate} 
                    checkerRemarks={checkerRemarks} 
                    isEditMode={isEditMode}
                    isReEditFlow={isReEditFlow}
                    infoMsgs={infoMsgs}
                    fieldName={fields.panDate.name}
                />

                <Field
                    name={fields.panDate.name}
                    type={fields.panDate.type}
                    id={fields.panDate.name}
                    component={DatePicker}
                    startDateId={fields.panDate.name}
                    singleDatePicker={true}
                    input={{value: panDate, onChange: handleDateChange}}
                    meta={{ touched: false, error: '' }} // Can be used for validation feedback
                    startDate={panDate}
                    numberOfMonths={1}
                    customClasses="form-date-input"
                    onSetStartDate={selectedDate => {
                        setPanDate(selectedDate);
                        
                    }}
                    placeholder={FORMAT_DATE}
                    onFocusedInput={setFocusedInput}
                    focusedInput={focusedInput}
                    disabled={
                        isViewMode || 
                        disableOtherFields ||
                        isApproved(checkerRemarks, fields.panDate.name, null, isEditMode)
                    }
                    isOutsideRange={() => false}
                />
            </div>
            {itemCount % 2 === 0 && <div className="form-field"></div>}
            <VerifyButton
            isVerified={isPanVerified}
            field={{...fields.verifyPan}}
            isDisable={
                isViewMode ||
                isPanVerifyDisable(piiData) ||
                isPanVerifyButtonDisable
            }
            handleClick={(e) => handleVerifyPiiAccount(e, {
                type: PAN,
                piiData,
                setIsUploading,
                setIsPiiVerified,
                setIntentId: setIntentId,
                intentId: intentId,
                actions: actions,
                formName: formName, 
                verifyFieldName: fields.verifyPan.name,
                setVerifiedDetails: setVerifiedDetails,
            })}
            />
        </>
    );
};

export default PanOcr;
